/**
 * One colour per market across the admin (Best Trades, Signal Analysis
 * Brief): INDIA amber, US sky, EUROPE violet, ASIA rose, CRYPTO lime — hues
 * chosen to avoid the pages' own meanings (green = gain, orange = SHORT).
 */
export const MARKET_COLOR = {
  INDIA: '#fbbf24',   // amber
  US: '#38bdf8',      // sky
  EUROPE: '#a78bfa',  // violet
  ASIA: '#fb7185',    // rose
  CRYPTO: '#bef264',  // lime
};
export const marketColor = (m) => MARKET_COLOR[(m || '').toUpperCase()] || '#94a3b8';
